module.exports = __webpack_public_path__ + "static/media/cunnane.13df4189.png";